import React from 'react'
import { Redirect, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { logException, logExceptionDebug } from 'lib/errors'
import { GA_EVENT, gtm } from 'lib/gtm'
import { LOGOUT_STATUS } from 'lib/constants'
import { stringToLocationObject } from 'lib/location'
import cookies from 'lib/cookies'
import { clearVerticalReferrer } from 'lib/verticalReferrer'
import { resetAuthSession } from './Auth'
import { debugLog } from 'lib/console'
import { getLocale } from 'lib/utils/getLocale'

const AuthSsoLogoutCallbackHandler = () => {
    const { i18n } = useTranslation(['common'])

    const match = useRouteMatch()
    let target = `${getLocale(i18n.language) || '/'}`

    const { status } = match.params

    debugLog('auth - AuthSsoLogoutCallbackHandler - target:', target, 'status:', status)

    switch (status) {
    case LOGOUT_STATUS.SUCCESS:
        target = cookies.get('logoutSuccessTarget') || target
        try {
            resetAuthSession()
            clearVerticalReferrer()
        } catch (e) {
            logException(e)
        }
        gtm.pushGaEvent(GA_EVENT.LOGOUT)
        break
    case LOGOUT_STATUS.FAILED:
        target = cookies.get('logoutFailedTarget') || target
        logExceptionDebug('Logout failed')
        break
    default:
        logException(`Invalid logout status: ${status}`)
    }

    return <Redirect to={stringToLocationObject(target)} />
}

export default AuthSsoLogoutCallbackHandler
